import {createSlice} from '@reduxjs/toolkit'
import CustomerService from '../../api/customer'
import {getCustomer} from '../auth'

export const voucherSlice = createSlice({
    name: 'voucher',
    initialState: {
        buttonIsDisabled: false,
        showLoader: false,
        modalIsActive: false,
        voucherData: {},
        disableTutorial: false,
        voucherErrorMessage: ''
    },
    reducers: {
        setButtonIsDisabled: (state, {payload}) => {
            state.buttonIsDisabled = payload
        },
        setShowLoader: (state, {payload}) => {
            state.showLoader = payload
        },
        setVoucherModalIsActive: (state, {payload}) => {
            state.modalIsActive = payload
        },
        setVoucherData: (state, {payload}) => {
            state.voucherData = payload
        },
        setVoucherErrorMessage: (state, {payload}) => {
            state.voucherErrorMessage = payload
        },
        setDisableTutorial: (state, {payload}) => {
            state.disableTutorial = payload
        }
    }
})

export const {
    setButtonIsDisabled,
    setShowLoader,
    setVoucherModalIsActive,
    setVoucherData,
    setVoucherErrorMessage,
    setDisableTutorial
} = voucherSlice.actions

export default voucherSlice.reducer

export const applyVoucher = formData => {
    return async dispatch => {
        try {
            const {data} = await CustomerService.applyVoucher(formData)
            dispatch(setVoucherData(data?.data))
            dispatch(setVoucherModalIsActive(true))
            await dispatch(getCustomer())
        } catch (e) {
            const error = e?.response?.data?.data?.fields?.code
            dispatch(setVoucherErrorMessage(error))
            dispatch(setVoucherModalIsActive(true))
        }
    }
}
